import { AttendanceWithApprovalsDto } from '@/services/api/attendance-day-api.ts';

export const convertHoursAndMinutesToSeconds = (
  hours: number,
  minutes: number
) => {
  return hours * 3600 + minutes * 60;
};

export function convertSecondsToHoursAndMinutes(seconds: number) {
  let hours = Math.floor(seconds / 3600);
  let minutes = Math.floor((seconds % 3600) / 60);

  return hours + ' 시간 ' + minutes + ' 분';
}

export function secondsToHoursAndMinutes(seconds: number) {
  const hours = Math.floor(seconds / 3600);
  //자동 신청의 경우 여유있게 신청하기 위해서 초단위를 올림해서 처리한다.
  const minutes = Math.ceil((seconds % 3600) / 60);

  return { hours, minutes };
}

export function calExtraWorkDayTime(item: AttendanceWithApprovalsDto) {
  if (item.holiday == 'Y') {
    return 0;
  }

  const computedTime = item.workExtraDayTime - (item.extraWork?.dayTime ?? 0);
  return computedTime > 0 ? computedTime : 0;
}

export function calExtraWorkNightTime(item: AttendanceWithApprovalsDto) {
  if (item.holiday == 'Y') {
    return 0;
  }

  const computedTime =
    item.workExtraNightTime - (item.extraWork?.nightTime ?? 0);
  return computedTime > 0 ? computedTime : 0;
}

export function calNightWorkTime(item: AttendanceWithApprovalsDto) {
  if (item.holiday == 'Y') {
    return 0;
  }

  let workNightTime = item.workAfterNightTime + item.workMorningNightTime;
  workNightTime = workNightTime - item.workExtraNightTime;

  const computedTime = workNightTime - (item.nightWork?.nightTime ?? 0);
  return computedTime > 0 ? computedTime : 0;
}

export function calHolidayWorkDayTime(item: AttendanceWithApprovalsDto) {
  if (item.holiday == 'N') {
    return 0;
  }

  const computedTime = item.workDayTime - (item.holidayWork?.dayTime ?? 0);
  return computedTime > 0 ? computedTime : 0;
}

export function calHolidayWorkNightTime(item: AttendanceWithApprovalsDto) {
  if (item.holiday == 'N') {
    return 0;
  }

  const computedTime =
    item.workMorningNightTime +
    item.workAfterNightTime -
    (item.holidayWork?.nightTime ?? 0);
  return computedTime > 0 ? computedTime : 0;
}
